<template>
    <el-aside width="100%">
        <!-- <el-input  
            placeholder="输入关键字定位"
            v-model="filterText">
        </el-input> -->
        

        <!-- <el-tree
            class="filter-tree"
            :data="tableData"
            :props="{ label: 'name' }"
            default-expand-all
            :filter-node-method="filterNode"
            ref="tree">
        </el-tree> -->

        <el-tree
		   style="height: 90vh"
            :data="tableData"
            :props="{ label: 'locationName' }"
            accordion
            node-key="id"
			:default-expanded-keys="permTreeIds"
            @node-click="handleNodeClick">
        </el-tree>
    </el-aside>
</template>

<script>
    export default {
        name: 'LocationTree',
        data() {
            return {
                tableData: [],
                permTreeIds: []
            }
        },
		created() {
			this.getLocationTree()
		},watch: {
			filterText(val) {
				this.$refs.tree.filter(val);
			}
		},
        methods: {
            getLocationTree() {
				this.$axios.get("/base/location/list").then(res => {
					this.tableData = res.data.data
                    
                    this.tableData.forEach(m=>{
                        console.log("m.id => " + m.id)
                        this.permTreeIds.push(m.id)
                    })
				})
			},
            filterNode(value, data) {
				if (!value) return true;
				return data.label.indexOf(value) !== -1;
			},
			handleNodeClick(data) {
                this.$emit('getTreeData', data);
				// console.log(data);
			}
        }
    } 
</script>

<style scoped >
	
</style>